import { Injectable } from '@angular/core';
import { MatSnackBarConfig } from '@angular/material';

@Injectable({
  providedIn: 'root'
})
export class BilSnackbarConfigService {

  private readonly config: MatSnackBarConfig;

  constructor(private readonly configurationService: BilSnackbarConfigService) {
    this.config = {
      duration: 3000,
      verticalPosition: 'top',
      horizontalPosition: 'center'
    };
  }

  public getSnackbarConfig(): MatSnackBarConfig {
    return this.config;
  }
}
